<template>
  <div id="app">
    <!-- v-if="isRouterAlive" -->
    <!-- :key="$route.path" -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
#app {
  font-family: "Microsoft YaHei", "微软雅黑", "Helvetica Neue", Helvetica,
    "PingFang SC", "Hiragino Sans GB", Arial, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
<style>
.el-textarea__inner {
  font-family: "Microsoft YaHei";
}
</style>


// WEBPACK FOOTER //
// src/App.vue